module.exports = __webpack_public_path__ + "static/media/avatar.3c9241c2.svg";